import {
  OPEN_APPROVAL_MODAL,
  OPEN_PROCESS_MODAL,
  OPEN_INFO_MODAL,
  OPEN_REFERENCE_MODAL,
  OPEN_CONTRIBUTOR_MODAL,
  OPEN_COMMENT_MODAL,
  CLOSE_APPROVAL_MODAL,
  CLOSE_PROCESS_MODAL,
  CLOSE_INFO_MODAL,
  CLOSE_REFERENCE_MODAL,
  CLOSE_CONTRIBUTOR_MODAL,
  CLOSE_COMMENT_MODAL
} from "../actions/types";

const initialState = {
  processModalIsOpen: false,
  approvalModalIsOpen: false,
  infoModalIsOpen: false,
  contributorModalIsOpen: false,
  referenceModalIsOpen: false,
  commentModalIsOpen: false,
  modalOpenTime: null
};
export default function(state = initialState, action) {
  switch (action.type) {
    case OPEN_APPROVAL_MODAL:
      return {
        ...state,
        approvalModalIsOpen: true,
        modalOpenTime: new Date()
      };
    case OPEN_PROCESS_MODAL:
      return {
        ...state,
        processModalIsOpen: true,
        modalOpenTime: new Date()
      };
    case OPEN_INFO_MODAL:
      return {
        ...state,
        infoModalIsOpen: true,
        modalOpenTime: new Date()
      };
    case OPEN_REFERENCE_MODAL:
      return {
        ...state,
        referenceModalIsOpen: true,
        modalOpenTime: new Date()
      };
    case OPEN_CONTRIBUTOR_MODAL:
      return {
        ...state,
        contributorModalIsOpen: true,
        modalOpenTime: new Date()
      };
    case OPEN_COMMENT_MODAL:
      return { ...state, commentModalIsOpen: true, modalOpenTime: new Date() };
    case CLOSE_APPROVAL_MODAL:
      return { ...state, approvalModalIsOpen: false };
    case CLOSE_PROCESS_MODAL:
      return { ...state, processModalIsOpen: false };
    case CLOSE_INFO_MODAL:
      return { ...state, infoModalIsOpen: false };
    case CLOSE_REFERENCE_MODAL:
      return { ...state, referenceModalIsOpen: false };
    case CLOSE_CONTRIBUTOR_MODAL:
      return { ...state, contributorModalIsOpen: false };
    case CLOSE_COMMENT_MODAL:
      return { ...state, commentModalIsOpen: false };
    default:
      return state;
  }
}
